<template>
  <div class="call_out_plan">
    <div class="fixed_search">
      <div class="fixed_search_input">
        <Input v-model="callPlan" placeholder="请输入呼出计划" title="呼出计划"/>
      </div>
      <div class="fixed_search_input">
        <Select
          v-model="executeStatus"
          clearable
          placeholder="请选择执行状态"
          transfer
        >
          <Option v-for="(status,index) in callStatus" :key="index" :value="status.value">{{status.label}}</Option>
        </Select>
      </div>
      <div class="fixed_search_input">
        <Select
          v-model="rwId"
          clearable
          placeholder="请选择AI流程"
          transfer
          title="AI流程"
        >
          <Option v-for="(ai,index) in aiFlow" :key="index" :value="ai.id+''">{{ai.rwName}}</Option>
        </Select>
      </div>
      <div class="date_input fixed_search_input">
        <el-date-picker v-model="starEndTime" unlink-panels type="datetimerange" start-placeholder="开始时间" end-placeholder="结束时间"
                        align="left" :default-time="['00:00:00', '23:59:59']"  :editable="editable" :picker-options="pickerOptions"  format="yyyy-MM-dd HH:mm:ss"  value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
      </div>
      <div class="fixed_operation_btn" style="width: auto">
        <Button type="primary" @click="initSearch">查询</Button>
        <Button type="info" @click="addCallPlan" v-if="roleList['a_3-1']">添加</Button>
      </div>
    </div>
    <div style="border-bottom: 1px solid rgb(235, 238, 245);" class="fixed_table">
      <Spin size="large" fix v-if="spinShow"><Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon><div>正在加载中...</div></Spin>
      <div class="table_head auto_call">
        <table style="white-space: nowrap;">
          <tr>
            <th class="font_style_set" style="width:2%;"><Checkbox v-model="checkedAll"  @on-change="checkedAllList()"></Checkbox></th>
            <th class="font_style_set" style="width: 8%">呼出计划</th>
            <th class="font_style_set" style="width: 8%">执行状态</th>
            <th class="font_style_set" style="width: 8%">AI流程</th>
            <th class="font_style_set" style="width: 10%">最近呼出时间</th>
            <th class="font_style_set" style="width: 9%">热线号码</th>
            <!--<th class="font_style_set" style="width: 8%">技能组名称</th>-->
            <th class="font_style_set" style="width: 10%">结束时间</th>
            <th class="font_style_set" style="width: 7%">呼出客户数</th>
            <th class="font_style_set" style="width: 7%">未呼叫数</th>
            <th class="font_style_set" style="width: 7%">未接通数</th>
            <th class="font_style_set" style="width: 7%">已接通数</th>
            <th class="font_style_set" style="width: 16%">操作</th>
          </tr>
        </table>
      </div>
      <div class="footer_style" :style="tableHeight">
        <table class="table_head_footer auto_call_footer">
          <tr v-for="(item , index) in infoTableList" :key="index" :id="item.id" :class="{back_color:(index+1)%2==0}">
            <td class="font_style_set" style="width:2%;"><CheckboxGroup v-model="singleCheckedList"><Checkbox :label="item.id"></Checkbox></CheckboxGroup></td>
            <td class="font_style_set" style="width: 8%" :title="item.taskName">{{item.taskName}}</td>
            <td class="font_style_set" style="width: 8%">{{item.taskStatus}}</td>
            <td class="font_style_set" style="width: 8%" :title="item.rwName">{{item.rwName}}</td>
            <td class="font_style_set" style="width: 10%" :title="item.lastBeginTime">{{item.lastBeginTime}}</td>
            <td class="font_style_set" style="width: 9%">{{item.pstnNumber}}</td>
            <!--<td class="font_style_set" style="width: 8%">{{item.queueName}}</td>-->
            <td class="font_style_set" style="width: 10%" :title="item.endTime">{{item.endTime}}</td>
            <td class="font_style_set" style="width: 7%"><a href="javascript:void(0)" :class="classForA(item.sums)" @click="getCustomerInfo(item.id,'2','0',item.sums)">{{item.sums}}</a></td>
            <td class="font_style_set" style="width: 7%"><a href="javascript:void(0)" :class="classForA(item.sumUncall)" @click="getCustomerInfo(item.id,'2','1',item.sumUncall)">{{item.sumUncall}}</a></td>
            <td class="font_style_set" style="width: 7%"><a href="javascript:void(0)" :class="classForA(item.sumFailure)" @click="getCustomerInfo(item.id,'2','3',item.sumFailure)">{{item.sumFailure}}</a></td>
            <td class="font_style_set" style="width: 7%"><a href="javascript:void(0)" :class="classForA(item.sumSuccess)" @click="getCustomerInfo(item.id,'2','2',item.sumSuccess)">{{item.sumSuccess}}</a></td>
            <td class="template_table_btn" style="width: 16%">
              <span class="search_btn" @click="editPlan(item.id)" v-if="roleList['a_3-2']">编辑</span>
              <span class="search_btn" @click="deletePlan(item.id)" v-if="roleList['a_3-3']">删除</span>
              <span class="search_btn" @click="importPhone(item.id,'2')" v-if="roleList['a_3-4']">导入号码</span>
              <span v-if="roleList['a_3-6']">
                    <span class="search_btn" @click="startAutoPlan(item.id)" v-if="(item.taskStatus=='已停止'||item.taskStatus=='未启动') && item.sums>0">启动</span>
                    <span class="search_btn" @click="stopAutoPlan(item.id)" v-if="item.taskStatus=='已启动'">停止</span>
                  </span>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="page_style">
      <Page :total="total" size="small" :page-size='pageSize' :current='currentPage' :page-size-opts="pageSizeList" show-total show-sizer  @on-change="changeCurrent" @on-page-size-change="changeSize"/>
      <div style="padding-top: 2px;">跳至</div><Input class="show-elevator" v-model="speedChangePage" @on-blur="handleCurrentPage"/><div style="padding-top: 2px;">页</div>
    </div>
    <AutoCallOutPop :optionsOfPlan="options" :maxLines="maxLines" :showAutoOutCall="showAutoOutCall" :callId="callId" :aiAutoCall="true"  @closeCallEditPop="closeCallEditPop" ></AutoCallOutPop>
    <searchCustomerInfoPop @closeCustomerInfo="closeCustomerInfo" @openTel="openTel" :selectCallId="selectCallId" :typeOfCallPlan="typeOfCallPlan" :showCustomerInfo="showCustomerInfo"></searchCustomerInfoPop>
    <ImportNumberPop :taskType="taskType" :showImportCallPop="showImportCallPop" :callId="callId" @closeCallEditPop="closeCallEditPop"></ImportNumberPop>
  </div>
</template>

<script>
  import {publicFunClass} from '@/components/js/PublicFunClass.js'
  import AutoCallOutPop from '@/components/callManage/AutoCallOutPop.vue'
  import searchCustomerInfoPop from '@/components/customerMange/SearchCustomerInfoPop.vue'
  import ImportNumberPop from '@/components/callManage/ImportNumberPop.vue'

  export default {
    name: "AICall",
    mixins: [publicFunClass],
    components:{
      searchCustomerInfoPop,
      AutoCallOutPop,
      ImportNumberPop,
    },
    props:{
      pageCode:String
    },
    data(){
      return {
        showPageCount:0,
        customList:[],
        taskType:'',
        showPublicBtn:false,
        checkedAll:false,
        singleCheckedList:[],
        infoTableList:[],
        callPlan:'',
        spinShow:true,
        executeStatus:'',
        editable:false,
        tableHeight:{height:''},
        starEndTime:[],
        roleList: JSON.parse(localStorage.getItem("roleList")),
        total:0,
        pageSizeList:[10,20,30,40,50,100,200],
        speedChangePage:1,
        currentPage:1,
        pageSize:20,
        configInfo: JSON.parse(localStorage.getItem("configInfo")),
        showAutoOutCall:false,
        callId:'',
        popSign:'呼出任务导出',
        checkIds:[],
        showCustomerInfo:false,
        showImportCallPop:false,
        typeOfCallPlan:'',
        selectCallId:'',
        options:[],
        callStatus:[{value:'0',label:'未启动'},{value:'1',label:'已启动'},{value:'2',label:'已停止'},{value:'3',label:'全部完成'}],
        aiFlow:[],
        rwId:'',
        aiFlags:'1',
        maxLines:0,
        menuId:'',
        journalType:'',
      }
    },
    methods:{
      openTel(row, column) {
        this.showCustomerInfo = false
        this.openCallScreen(row,column)
      },
      classForA(i) {
        let flag = parseInt(i)
        if (flag > 0) {
          return 'undeline_out_call';
        } else {
          return 'undelined_out_call_null'
        }
      },
      closeCustomerInfo(flag) {
        this.showCustomerInfo = false
        if (flag) {
          this.initSearch()
        }
      },
      getCustomerInfo(id, type, allcostate, number) {
        if (number != '0') {
          this.showCustomerInfo = true
          this.selectCallId = id + ''
          this.typeOfCallPlan = type + ',' + allcostate
        }
      },
      initSearch() {
        let that = this
        let param = {
          journalType:'null',
          menuId:'null',
          pageNum:this.currentPage,
          pageSize:this.pageSize,
          taskType:'2',
          taskName:this.callPlan,
          taskPurpose:this.executeStatus,
          startTime:this.starEndTime.length==0?"":this.starEndTime.toString(),
          //add AI type
          aiFlags: this.aiFlags,
          rwId:this.rwId,
          taskStatus:this.executeStatus,
        }
        this.spinShow = true
        this.$http.post('calltask/selectCallTask.json',param).then(res=>{
          let response = res.data
          that.spinShow = false
          if (response.flag !== '666') {
            that.$Modal.info({
              title:'提示',
              content:response.msg
            })
            return false
          }
          that.infoTableList=response.obj.list.content
          that.total = response.obj.list.totalSize
          that.options = response.obj.type
          that.maxLines = response.obj.maxLines
        })
      },
      importPhone(id, taskType) {
        this.showImportCallPop = true
        this.callId = id + ''
        this.taskType = taskType
      },
      closeCallEditPop(flag) {
        this.showAutoOutCall=false
        this.showImportCallPop=false
        if (flag) {
          this.initSearch()
        }
      },
      addCallPlan() {
        this.showAutoOutCall=true
        this.callId=''
        this.options=this.options
      },
      editPlan(id) {
        this.showAutoOutCall = true
        this.callId = id + ''
        this.options = this.options
      },
      deletePlan(id) {
        let that = this
        let param = {
          journalType:'AI机器人管理=>AI呼叫管理=>删除AI呼叫',
          menuId:'a_3-3',
          id:id,
          taskType:'2',
          //add ai type
        }
        this.$Modal.confirm({
          title: '提示',
          content:'是否确定删除',
          onOk:()=>{
            that.$http.post('calltask/deleteCallTask.json',param).then(res=>{
              let response = res.data
              if (response.flag !== '666') {
                that.$alert(response.msg,'提示',{
                  confirmButtonText:'确定'
                })
                return false
              }
              that.$Message.info('删除成功')
              that.initSearch()
            })
          }
        })
      },
      startAutoPlan(id) {
        let that = this
        let param = {
          id:id,
          isStart:false,
          journalType:'AI机器人管理=>AI呼叫管理=>启动呼叫任务',
          menuId:'a_3-6',
          aiFlags:this.aiFlags,
        }
        this.$http.post('calltask/startCallTask.json',param).then(res=>{
          let response = res.data
          if (response.flag !== '666') {
            that.$alert(response.msg,'提示',{
              confirmButtonText:'确认'
            })
            return false
          }
          let content = response.msg
          param = {
            id:id,
            isStart: true,
            journalType: 'AI机器人管理=>AI呼叫管理=>启动呼叫任务',
            menuId: 'a_3-6',
            aiFlags:this.aiFlags,
          }
          that.$Modal.confirm({
            title:'提示',
            content:content,
            onOk:()=>{
              that.$http.post('calltask/startCallTask.json',param).then(res=>{
                let response = res.data
                if (response.flag !== '666') {
                  that.$alert(response.msg,'提示',{
                    confirmButtonText:'确认'
                  })
                  return false
                }
                that.$Message.info('启动成功')
                that.initSearch()
              })
            }
          })
        })
      },
      stopAutoPlan(id) {
        let that = this
        let param = {
          id:id,
          journalType:'AI机器人管理=>AI呼叫管理=>停止呼叫任务',
          menuId:'a_3-6'
        }
        this.$http.post('calltask/stopCallTask.json',param).then(res=>{
          let response = res.data
          if (response.flag !== '666') {
            that.$alert(response.msg,'提示',{
              confirmButtonText:'确认'
            })
            return false
          }
          that.$Message.info('停止成功')
          that.initSearch()
        })
      },
    },
    created() {
      this.tableHeight.height = this.mountHeight(225)
    },
    watch:{
      pageCode(){
        if (this.pageCode == 'a_3' && this.showPageCount == 0) {
          this.showPageCount++
          this.initSearch()
          this.getAIWorkFlow()
        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/aiManager/AICall.vue